import jQuery from 'jquery'

// Active Bookings
const activeForm = jQuery('#mybookings-active-form')
const activeSortDate = jQuery('#activeSortDate')
const activeSortTotal = jQuery('#activeSortTotal')
const activeSortDateBtn = jQuery('#activeSortDateBtn')
const activeSortTotalBtn = jQuery('#activeSortTotalBtn')
const activeSortSlct = jQuery('#activeSortSlct')

activeSortSlct.on('change', () => {
  const value = jQuery(this).val()

  activeSortDate.val('')
  activeSortTotal.val('')

  if (value.includes('date')) {
    activeSortDate.val(value)
  }
  if (value.includes('total')) {
    activeSortTotal.val(value)
  }

  activeForm.submit()
})

activeSortDateBtn.on('click', () => {
  activeSortTotal.val('')
  if (activeSortDate.val() === '' || activeSortDate.val() === 'date_asc') {
    activeSortDate.val('date_desc')
  } else {
    activeSortDate.val('date_asc')
  }
})

activeSortTotalBtn.on('click', () => {
  activeSortDate.val('')
  if (activeSortTotal.val() === '' || activeSortTotal.val() === 'total_asc') {
    activeSortTotal.val('total_desc')
  } else {
    activeSortTotal.val('total_asc')
  }
})

// History Bookings
const historyForm = jQuery('#mybookings-history-form')
const historySortDate = jQuery('#historySortDate')
const historySortTotal = jQuery('#historySortTotal')
const historySortDateBtn = jQuery('#historySortDateBtn')
const historySortTotalBtn = jQuery('#historySortTotalBtn')
const historySortSlct = jQuery('#historySortSlct')

historySortSlct.on('change', () => {
  const value = jQuery(this).val()

  historySortDate.val('')
  historySortTotal.val('')

  if (value.includes('date')) {
    historySortDate.val(value)
  }
  if (value.includes('total')) {
    historySortTotal.val(value)
  }

  historyForm.submit()
})

historySortDateBtn.on('click', () => {
  historySortTotal.val('')
  if (historySortDate.val() === '' || historySortDate.val() === 'date_asc') {
    historySortDate.val('date_desc')
  } else {
    historySortDate.val('date_asc')
  }
})

historySortTotalBtn.on('click', () => {
  historySortDate.val('')
  if (historySortTotal.val() === '' || historySortTotal.val() === 'total_asc') {
    historySortTotal.val('total_desc')
  } else {
    historySortTotal.val('total_asc')
  }
})
